import React, { Component } from 'react';
import { Row, Col, Form, Tooltip, OverlayTrigger } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';
import { ColorButton, DeleteModal, EmptyStateContainer, AddPropertyModal, SwitchContainer, PageHeader } from '../../../../neoverv';

// import de from
import DatePicker, { registerLocale } from 'react-datepicker';
import de from 'date-fns/locale/de';
import Autoload from '../../../../neoverv/Autoload';
import { isStarterTier, isPremiumTier } from '../../../../helpers/subscriptionFeatureAccess';
import { connect } from 'react-redux';
import moment from 'moment';
import {
  updatePropetyInfo,
  editProfileData,
  deleteProperty,
  setPropertyList,
  changeCurrentProperty,
} from '../../../../redux/action/General/generalActions';
import { hideNotification, showNotification } from '@mantine/notifications';
import RedCross from '../../../../assets/images/module/general/RedCross.svg';
import GreenTick from '../../../../assets/images/module/general/GreenTick.svg';
import { Box, Grid, Group, Overlay, SimpleGrid, Skeleton, Stack, TextInput } from '@mantine/core';
import AddPropertyTypeModal from '../../../../neoverv/components/Module/General/CustomModal/AddPropertyTypeModal.jsx';
import PropertyDataHandler from '../../../../neoverv/helpers/DataHandler/Property';

var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];
registerLocale('de', de);
class CondominiumAssociation extends Component {
  state = {
    isMobile: false,
    skeletonLoading: false,
    file: null,
    selectedPropertyType: null,
    isWegModeActive: false,
    propertyData: null
  };

  componentDidMount() {
    this.setState({skeletonLoading: true});
    if(this.props.propertyData && this.props.propertyData.id !== undefined){
      this._fetchGeneralInfoData();
    }else{
      this.ShowLoader();
    }
  }

  toggleAddPropertyModal = () => {
    this.setState({ addPropertyModal: !this.state.addPropertyModal });
  };
  toggleAddPropertyTypeModal = () => {
    this.setState({ addPropertyTypeModal: !this.state.addPropertyTypeModal });
  };

  _getPropertyPicture() {
    const propertyID = this.props.propertyData.id;
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.property_api_base_url + 'properties/' + propertyID + '/picture',
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      '_getPropertyPictureResponse',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  _getPropertyPictureResponse(response) {
    if (response.status == true && response.statuscode == 200) {
      this.setState({ file: response.result });
    }
  }

  _fetchGeneralInfoData() {
    const propertyID = this.props.propertyData.id;
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.property_api_base_url + 'properties/' + propertyID,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handle_get_property_data',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handle_get_property_data(response) {
    const {propertyOwner, isPropertyOwnerInfoEnabled, isPropertyOwnerInfoInMessagesEnabled} = this.props.propertySelected;
    const {changeCurrentProperty, propertySelected} = this.props;
    if (response.status == true && response.statuscode == 200) {
      if(response.result){
        let property = PropertyDataHandler.getProperty(response.result);
        this.setState({
          propertyData: property,
          isWegModeActive: response.result?.isWegModeActive || false,
        });
      }
    }
    this.ShowLoader();
  }

  _addGeneralInfo(callBackFunction=null) {
    hideNotification('save_property_data');
    hideNotification('save_property_data_error');
    const {propertySelected} = this.props;
    const {isWegModeActive} = this.state;

    const propertyID = this.props.propertyData.id;
    const accountID = this.props.profileData.accountId;

    const generalInfoData ={
      ...propertySelected,
      propertyId: propertyID,
      accountId: accountID,
      name: propertySelected.name,
      propertyAdress: {
        streetno: propertySelected.propertyAddress,
        city: propertySelected.propertyCity,
        zipCode: propertySelected.propertyZipCode,
      },
      totalRentingSpace: propertySelected.totalRentingSpace,
      numberOfRentalUnits: propertySelected.numberOfRentalUnits,
      cutOffDate: propertySelected.cutOffDate,
      heatingType: propertySelected.heatingType,
      heatingTemperature: propertySelected.heatingTemperature,
      consumptionShare: propertySelected.consumptionShare,
      energyFuelType: propertySelected.energyFuelType,
      receiptEmail: propertySelected.receiptEmail,
      meterReadingsEmail: propertySelected.meterReadingsEmail,
      centralWarmwaterAllocationKey: propertySelected.centralWarmwaterAllocationKey,
      isMeterReadingConducted: propertySelected.isMeterReadingConducted,
      propertyType: propertySelected.propertyType,
      occupantsConfiguration: propertySelected.occupantsConfiguration,
      pictureLocation: propertySelected.pictureLocation,
      isConsumptionSectionHidden: propertySelected.isConsumptionSectionHidden,
      isDocumentSectionHidden: propertySelected.isDocumentSectionHidden,
      isMessageSectionHidden: propertySelected.isMessageSectionHidden,
      isWegModeActive
    }
    console.log('generalInfoData', generalInfoData);
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.property_api_base_url + 'properties/' + propertyID,
      'PUT',
      generalInfoData,
      null,//btnelement.children[0],
      false,
      true,
      false,
      this,
      '_PutGeneralInfoResponse',
      { generalInfoData, callBackFunction },
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  _PutGeneralInfoResponse(response) {
    if(response.status && response.statuscode === 200){
      showNotification({
        id: 'save_property_data',
        icon: <img src={GreenTick} alt='green-tick'/>,
        message: 'Die Änderungen wurden übernommen.',
      });
      this.updateProperties(response.other.generalInfoData);
    }else{
      showNotification({
        id: 'save_property_data_error',
        icon: <img src={RedCross} alt='red-cross'/>,
        message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
      });
    }
  }

  updateProperties(updated_property_response, deleteProperty=false, callBackFunction=null) {
    const {isWegModeActive} = this.state;
    let {propertySelected} = this.props;
    propertySelected={
      ...propertySelected,
      ...updated_property_response,
      isWegModeActive
    }

    this.props.changeCurrentProperty(propertySelected);

    if(callBackFunction){
      callBackFunction();
    }
  }

  ShowLoader = () => {
    this.setState({skeletonLoading: false});
  };

  onInputChangeForPropertyOwnerObject=(value, field)=>{
    let {propertyOwner} = this.state;
    propertyOwner[field] = value?.length > 0 ? value : null;
    this.setState({propertyOwner});
  }

  render() {
    const {propertySelected, isMobile, currentSubscription, accountData} = this.props;
    const {selectedPropertyType, addPropertyTypeModal, addPropertyModal, isWegModeActive, skeletonLoading} = this.state;

    console.log('propertySelected_231234: ', propertySelected);
    //let disableDisplayPropertyOwnerInfoInMessages = (propertyOwner?.name && propertyOwner?.street && propertyOwner?.city && propertyOwner?.postalCode && propertyOwner?.email) ? false : true;
    const professionalOverlay = (isStarterTier(currentSubscription) || isPremiumTier(currentSubscription));
    return (
      <>
        <div id="empty-generalinfo-page"></div>
        <Box sx={{ height: '100%', position: 'relative'}}>
          <div style={{ position: 'relative', maxWidth: isMobile ? 'auto' : '460px', marginTop: professionalOverlay && '40px'}}>
            {professionalOverlay &&
            <Stack align={'center'} style={{ zIndex: 50, position: 'absolute', left: 0, right: 0, marginRight: 'auto', marginLeft: 'auto', marginTop: '150px'}}>
              <Stack gap={0}>
                <span style={{color: '#0E0E1D', fontSize: '25px', fontWeight: 'bold', textAlign: 'center'}}>Professionelle Hausverwaltung</span>
                <span style={{color: '#5555FF', fontSize: '25px', fontWeight: 'bold', textAlign: 'center'}}>Mit hellohousing Professional.</span>
              </Stack>
              <Group>
                <div>
                  <ColorButton
                  text={'Jetzt freischalten'}
                  className='purple-btn'
                  onClick={()=> this.props.history.push('/profile/yourSubscription', {newSubscription: true})}
                  />
                </div>
              </Group>
              <Group style={{width: '460px'}}>
                <span style={{color: '#615C7E', fontSize: '12px', textAlign: 'center'}}>Hinterlegen Sie Informationen zum Eigentümer, um Objekte im Eigentümerauftrag mit hellohousing zu verwalten.</span>
              </Group>
              {/* <Group>
                <span style={{color: '#5555FF', marginLeft: '5px', fontSize: '14px', cursor: 'pointer'}} onClick={()=> window.Intercom('showArticle', '6776182')}>Zählerdatenverarbeitung kennenlernen</span>
              </Group> */}
            </Stack>}
            {professionalOverlay &&
            <Overlay opacity={0.5} blur={4} zIndex={5} color={'#F7F7FA'}/>}
          <div className="propertyOwnerinfo-page" id="respond-propertyOwnerinfo-page" style={{ display: 'block' }}>
          <PageHeader
            heading={!isMobile && <Skeleton style={{marginTop: '7px'}} visible={skeletonLoading}>{'WEG-Verwaltung'}</Skeleton>}
            headingClassName={'tooltips property-condominium-association-heading'}
            hideDivider={true}
            searchElement={
            <Group style={{marginTop: '19px'}}>
              <SwitchContainer
              switchText={'WEG-Verwaltung Funktionen für diese Immobilie aktivieren'}
              checked={isWegModeActive}
              onChange={()=> this.setState({isWegModeActive: !isWegModeActive}, ()=> this._addGeneralInfo())}
              disabled={skeletonLoading}
              className={'enable-property-owner-information-switch'}
              textClassName={'tooltips enable-condominium-association-switch-label'}
              />
            </Group>}
          />
        </div>
        </div>
        {addPropertyModal &&
        <AddPropertyModal
          className="add_proprty_modal"
          edit={false}
          open={addPropertyModal}
          toggle={() => {
            this.toggleAddPropertyModal();
          }}
          propertyType={selectedPropertyType}
        />}
        {addPropertyTypeModal &&
        <AddPropertyTypeModal
          className="add_proprty_type_modal"
          open={addPropertyTypeModal}
          toggle={() => {
            this.toggleAddPropertyTypeModal();
          }}
          next={(selectedPropertyType)=> {
            this.setState({selectedPropertyType});
            this.toggleAddPropertyTypeModal();
            this.toggleAddPropertyModal();
          }}
          history={this.props.history}
        />}
        </Box>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    propertyData: state.generalReducer.property,
    profileData: state.generalReducer.profile,
    allProperties: state.generalReducer.allProperties,
    propertySelected: state.generalReducer.property,
    accountData: state.generalReducer.accountData,
    currentSubscription: state.generalReducer.currentSubscription,
  };
};

const actions = {
  updatePropetyInfo,
  deleteProperty,
  editProfileData,
  setPropertyList,
  changeCurrentProperty,
  updatePropetyInfo,
};

export default connect(mapStateToProps, actions)(CondominiumAssociation);
